import React from "react";
import { Routes, Route } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Header from "./components/Header/header.js";
import Footer from "./components/Footer/footer.js";
import Home from "./pages/Home/home.js";
import { MyContext } from "./Mycontext.js";
import Connexion from "./pages/Connexion/connexion.js";
import Projets from "./pages/Projets/projets.js";
import Admin from "./pages/Admin/admin.js";
import NotFound from "./pages/404/notFound.js";
import ProjetDetail from "./pages/ProjetDetail/projetdetail.js";
import CV from "./pages/CV/cv.js";
import AjouterProjet from "./pages/Admin/ajouterProjet";
import EditerProjet from "./pages/Admin/editerProjet.js";
import DeleteProjet from "./pages/Admin/deleteProjet.js";

function App() {
  const basenameValue = "/APP";

  return (
    <MyContext.Provider value={{ basename: basenameValue }}>
      <Analytics />
      <SpeedInsights />
      <div>
        <Header />
      </div>

      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/projets" element={<Projets />} />
          <Route path="/projetdetail/:id" element={<ProjetDetail />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/*" element={<NotFound />} />
          <Route path="/Admin/editerProjet/:id" element={<AjouterProjet />} />
          <Route path="/editer/:id" element={<EditerProjet />} />
          <Route path="/Admin/deleteProjet/:id" element={<DeleteProjet />} />
        </Routes>
      </div>
      <div>
        <Footer />
      </div>
    </MyContext.Provider>
  );
}

export default App;
